//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.10.0 (NJsonSchema v10.6.10.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    validateSession(body: ValidateSessionRequest | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Session";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidateSession(_response);
        });
    }

    protected processValidateSession(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getSessions(): Promise<SignInSession[]> {
        let url_ = this.baseUrl + "/api/Session";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSessions(_response);
        });
    }

    protected processGetSessions(response: Response): Promise<SignInSession[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SignInSession.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SignInSession[]>(null as any);
    }

    /**
     * @param sid (optional) 
     * @return OK
     */
    terminateSessions(sid: string | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Session?";
        if (sid === null)
            throw new Error("The parameter 'sid' cannot be null.");
        else if (sid !== undefined)
            url_ += "sid=" + encodeURIComponent("" + sid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTerminateSessions(_response);
        });
    }

    protected processTerminateSessions(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class SignInSession implements ISignInSession {
    sub?: string;
    sid?: string;
    iat?: Date;
    exp?: Date;
    agent?: string | undefined;
    ip?: string | undefined;
    active?: boolean;
    updatedOn?: Date;

    constructor(data?: ISignInSession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sub = _data["sub"];
            this.sid = _data["sid"];
            this.iat = _data["iat"] ? new Date(_data["iat"].toString()) : <any>undefined;
            this.exp = _data["exp"] ? new Date(_data["exp"].toString()) : <any>undefined;
            this.agent = _data["agent"];
            this.ip = _data["ip"];
            this.active = _data["active"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SignInSession {
        data = typeof data === 'object' ? data : {};
        let result = new SignInSession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sub"] = this.sub;
        data["sid"] = this.sid;
        data["iat"] = this.iat ? this.iat.toISOString() : <any>undefined;
        data["exp"] = this.exp ? this.exp.toISOString() : <any>undefined;
        data["agent"] = this.agent;
        data["ip"] = this.ip;
        data["active"] = this.active;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISignInSession {
    sub?: string;
    sid?: string;
    iat?: Date;
    exp?: Date;
    agent?: string | undefined;
    ip?: string | undefined;
    active?: boolean;
    updatedOn?: Date;
}

export class ValidateSessionRequest implements IValidateSessionRequest {
    agent?: string | undefined;
    ip?: string | undefined;

    constructor(data?: IValidateSessionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agent = _data["agent"];
            this.ip = _data["ip"];
        }
    }

    static fromJS(data: any): ValidateSessionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateSessionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agent"] = this.agent;
        data["ip"] = this.ip;
        return data;
    }
}

export interface IValidateSessionRequest {
    agent?: string | undefined;
    ip?: string | undefined;
}

export class ApiException extends Error {
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}